import * as React from 'react';

import Loader from 'components/atoms/Loader';
import withVirtualPageView from 'components/hoc/withVirtualPageView';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';
import Profile from 'containers/organisms/Profile/Profile';

type ProfileViewProps = WithVirtualPageView & {
	isLoading: boolean;
};

export class ProfileView extends React.Component<ProfileViewProps> {
	public static displayName = 'ProfileView';

	public tracked = false;

	public render() {
		const { isLoading, trackVirtualPageView } = this.props;

		if (isLoading) {
			return <Loader />;
		}

		if (!this.tracked) {
			trackVirtualPageView({});
			this.tracked = true;
		}

		return <Profile />;
	}
}

export default withVirtualPageView(ProfileView);
